module.exports = __webpack_public_path__ + "static/t1-c6f997490d1ca03a8e0d0d5b1a3dfafe.jpg";